module.exports = __webpack_public_path__ + "media/images/team/team2-d6289ceb668163ca50ea07f678793444.jpg";